import Home from '../sections/home/Home';
import App from '../App';

window.App = App;
window.Section = Home;


